import { render, staticRenderFns } from "./AddEstablishmentTransferPage.vue?vue&type=template&id=c1bb17f0"
import script from "./AddEstablishmentTransferPage.vue?vue&type=script&lang=js"
export * from "./AddEstablishmentTransferPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports